import styled from '@emotion/styled';
import type { FunctionComponent } from 'react';
import type Maybe from 'true-myth/maybe';

import type { SkillType } from '~/shared/data-contract/skill';

import { RequiredSectionTitle } from './RequiredSectionTitle';
import { SkillTag } from './SkillTag';
import { useFeedbackDialogStore } from './use-feedback-dialog-store';

const SelectorContainer = styled.div({
    display: 'flex',
    flexDirection: 'column',
});

const SkillsRow = styled.div({
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0.5rem',
});

export type SkillTypeSelectorProps = {
    readonly onSkillTypeSelected: (type: SkillType, currentlySelected: Maybe<SkillType>) => void;
    readonly selectedType: Maybe<SkillType>;
};

export const SkillTypeSelector: FunctionComponent<SkillTypeSelectorProps> = ({ onSkillTypeSelected, selectedType }) => {
    const createSkillSkillTypeLabel = useFeedbackDialogStore((state) => state.createSkillSkillTypeLabel);
    const hardSkillLabel = useFeedbackDialogStore((state) => state.hardSkillLabel);
    const languageSkillLabel = useFeedbackDialogStore((state) => state.languageSkillLabel);
    const softSkillLabel = useFeedbackDialogStore((state) => state.softSkillLabel);

    const handleSkillClick = (type: SkillType): void => {
        onSkillTypeSelected(type, selectedType);
    };

    const isSelected = (type: SkillType): boolean => {
        return selectedType.unwrapOr(false) === type;
    };

    return (
        <SelectorContainer>
            <RequiredSectionTitle>{createSkillSkillTypeLabel}</RequiredSectionTitle>
            <SkillsRow>
                <SkillTag
                    isActive={isSelected('hard')}
                    label={hardSkillLabel}
                    type="hard"
                    onClick={() => handleSkillClick('hard')}
                />
                <SkillTag
                    isActive={isSelected('soft')}
                    label={softSkillLabel}
                    type="soft"
                    onClick={() => handleSkillClick('soft')}
                />
                <SkillTag
                    isActive={isSelected('language')}
                    label={languageSkillLabel}
                    type="language"
                    onClick={() => handleSkillClick('language')}
                />
            </SkillsRow>
        </SelectorContainer>
    );
};
